import request from '@/utils/request';
import { eCommand, ePowerMode } from '@/interface/eCommand';

export const getArea = () =>
  request({
    url: '/api/v1/omc/area',
    method: 'get',
  });

export const getAreaCount = (params: any) =>
  request({
    url: '/api/v1/omc/area_count',
    method: 'get',
    params,
  });

export const getAreaDetail = (params?: any) =>
  request({
    url: '/api/v1/omc/area_detail',
    method: 'get',
    params,
  });

export const putAreaDetail = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/area_detail',
    method: 'put',
    data,
  });
export const putDispatchType = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/area/switch/dispatch_type',
    method: 'put',
    data,
  });

export const delAreaDetail = (id: number) =>
  request({
    url: `/api/v1/omc/area_detail?areaid=${id}`,
    method: 'delete',
    data: {
      areaid: id,
    },
  });

// 云电脑
export const getMachines = (params?: any) =>
  request({
    url: '/api/v1/omc/machine',
    method: 'get',
    params,
  });

// 节点列表详情
export const getAreaDetailByAreaID = (params?: any) =>
  request({
    url: '/api/v1/omc/area_info',
    method: 'get',
    params,
  });

export const putMachines = (data: any): any =>
  request({
    url: '/api/v1/omc/machine',
    method: 'put',
    data,
  });

export const delMachines = (data: number[]) => {
  let params = data.toString();

  return request({
    url: `/api/v1/omc/machine?ids=${params}`,
    method: 'delete',
    data,
  });
};

/**
 * 修改设备的状态
 * @param id 设备ID
 * @param instruct 操作类型
 */
export const instructRequest = (id: number, instruct: eCommand) => {
  return request({
    url: `/api/v1/omc/instruct`,
    method: 'get',
    params: {
      id,
      instruct,
    },
  });
};

/**
 * 是否开启节能模式
 * @param areaid 网吧ID,多网吧ID用逗号隔开
 */
export const switchWhiteList = (areaid: string) =>
  request({
    url: `/api/v1/omc/switch_whitelist`,
    method: 'get',
    params: {
      areaid,
    },
  });

/**
 * 重新刷新数据
 */
export const reloadData = () =>
  request({
    url: `/api/v1/omc/all_area_reload`,
    method: 'put',
  });

/**
 * 修改设备的收费方式
 * @param ids 设备ID
 * @param isfree 收费方式
 */
export const patternEdit = (data: any) => {
  return request({
    url: `/api/v1/omc/machine/switch_free`,
    method: 'put',
    data,
  });
};
/**
 * 设置配置
 * @param ids 设备ID
 * @param isfree 收费方式
 */
export const setSwitchConfig = (data: any) => {
  return request({
    url: `/api/v1/omc/machine/switch_config`,
    method: 'put',
    data,
  });
};

/**
 * 故障维护说明
 * @param id 设备ID
 * @param remark 描述
 * @param type  4=故障维护，5=解除维护/
 */
export const repairEditData = (data: any): Promise<any> => {
  return request({
    url: `/api/v1/omc/host/repair`,
    method: 'post',
    data,
  });
};
/**
 * 批量直接归还共享调度的机器

 */
export const returnIndirect = (data: any): Promise<any> => {
  return request({
    url: `/api/v1/omc/area/share/indirect/return/batch`,
    method: 'put',
    data,
  });
};
